import serviceRequest from './service_request/store/index'

export default {
  modules: {
    serviceRequest
  }
}



// WEBPACK FOOTER //
// ./src/components/sourcing_workflow/store.js